import { render } from "./OverviewTemp.vue?vue&type=template&id=4288b51a"
import script from "./OverviewTemp.vue?vue&type=script&lang=js"
export * from "./OverviewTemp.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__